import Flickity from 'flickity/js/index';
import FlickityFade from 'flickity-fade/flickity-fade';
import * as ScrollLock from 'scroll-lock';

window.theme = window.theme || {};
window.theme.Flickity = Flickity;
window.theme.FlickityFade = FlickityFade;
window.theme.ScrollLock = ScrollLock;
